import React from 'react'
import ProjectExample from '../../../assets/project-page-example.png'
import { CheckMark } from './checkMark'
import { Testimonial } from '../../utils/testimonial'

export function Sidebar() {
  return (
    <div className="max-w-md mx-auto">
      <img src={ProjectExample} alt="project-example" className="w-full max-w-sm h-auto mx-auto mb-6" />
      <div className="px-4 mb-8">
        <div className="space-y-3">
          {['Take notes alongside AI', 'Collaborate with your team on interviews', 'Export to any tool'].map(
            (text, index) => (
              <CheckMark text={text} key={index} />
            )
          )}
        </div>
      </div>
      <div className="px-4 pb-8">
        <Testimonial />
      </div>
    </div>
  )
}
